import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { delimitNumber, formatDiscountValue } from '@src/utils';
import { calculateTotalInvoice } from '@src/services/order';
import { StyledInvoice } from './index.style';
import { calculateDiscountedPrice } from '../ultis';

const Invoice = ({ products = [], discountAll = 0 }) => {
  const payment = calculateTotalInvoice(products, discountAll);

  return (
    <StyledInvoice>
      <Typography
        width="100%"
        textAlign="center"
        fontWeight={600}
        fontSize={18}
        mb="36px"
      >
        HÓA ĐƠN
      </Typography>
      <Table sx={{ borderCollapse: 'collapse' }} aria-label="Khong Kinh">
        <TableHead>
          <TableRow>
            <TableCell className="border header" align="center">
              STT
            </TableCell>
            <TableCell className="border header" align="center" width="35%">
              Sản phẩm/Dịch vụ
            </TableCell>
            <TableCell className="border header" align="center">
              Số lượng
            </TableCell>
            <TableCell className="border header" align="center">
              Đơn giá
            </TableCell>
            <TableCell className="border header discount" align="center">
              Chiết khấu
            </TableCell>
            <TableCell className="border header" align="center">
              Thành tiền
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {products.map((item, index) => (
            <TableRow key={item.product?.id}>
              <TableCell
                className="border invoice-cell"
                component="th"
                scope="row"
                align="center"
              >
                {index + 1}
              </TableCell>
              <TableCell className="border invoice-cell" align="center">
                {item.product?.name}
                {}
              </TableCell>
              <TableCell className="border invoice-cell" align="center">
                {item.quantity}
              </TableCell>
              <TableCell className="border invoice-cell" align="center">
                {delimitNumber(item.priceOut)}
              </TableCell>
              <TableCell className="border invoice-cell" align="center">
                {formatDiscountValue(item.discount)}
              </TableCell>
              <TableCell className="border invoice-cell" align="center">
                {calculateDiscountedPrice({
                  priceOut: item.priceOut,
                  quantity: item.quantity,
                  discount: item.discount,
                })}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className="total-payment">
        <p>Tổng: {delimitNumber(payment?.total)} đ</p>
        <p>Giảm giá: -{delimitNumber(payment?.reduction)} đ</p>
        <p>Thanh toán: {delimitNumber(payment?.mustPay)} đ</p>
      </div>
    </StyledInvoice>
  );
};

export default Invoice;
